/* unplugin-vue-components disabled */import script from "./KbDetailPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KbDetailPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./KbDetailPreviewModal.vue?vue&type=style&index=0&id=5bdc4afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdc4afe"]])

export default __exports__